<div class="grid-container margin-top">
  <div class="grid-x grid-margin-x">
    <div class="cell large-2 small-3 medium-2 text-align-right padding-right">
      <label for="fromDate">From:</label>
    </div>
    <div class="cell large-2 medium-2 small-3">
      <common-date-picker [id]="'fromDate'" (dateUpdated)="fromDateChanged($event)" [initialDate]="fromDate"></common-date-picker>
    </div>
    <div class="cell large-2 small-3 medium-2 text-align-right padding-right">
      <label for="toDate">To:</label>
    </div>
    <div class="cell large-2 medium-2 small-3">
      <common-date-picker [id]="'toDate'" (dateUpdated)="toDateChanged($event)" [initialDate]="toDate"></common-date-picker>
    </div>
    <div class="cell large-4 medium-4 small-6">
      @if (invalidDates) {
        <span class="red italic">
          From date must be less than or equal to To date.
        </span>
      }
      @if (datesRequired) {
        <span class="red italic">
          From date and To date are required.
        </span>
      }
    </div>
  </div>
</div>
<div class="grid-container extra-wide margin-bottom">
  <div class="grid-x grid-margin-x">
    <div class="cell text-align-center">
      <ag-grid-angular class="data-grid  full-page" [gridOptions]="gridOptions" [rowData]="data$ | async" (firstDataRendered)="resizeColumns()" (paginationChanged)="resizeColumns()" [excelStyles]="excelStyles" aria-label="Stratigraphic Wells Report"></ag-grid-angular>
    </div>
  </div>
</div>